import React, { useEffect, useRef } from 'react';
import './index.scss';
import clsx from 'clsx';

const PcSuggestList = ({ items = [], onClick, fullWidth = false }) => {
  const els = useRef([]);
  useEffect(() => {
    const suggestText = document.getElementById('suggestText');
    suggestText.addEventListener('keydown', (e) => {
      // Enter Key
      if (e.key === 'Enter' && 
        typeof els.current[0] !== 'undefined' &&
         els.current[0] !== null) {
        e.preventDefault();        
        if(els.current[0].focus())els.current[0].focus();
      }
    }, false );
  }, []);
  return(
    <div className={clsx(
      'PcSuggestList',
      { many: items.length > 5 },
      { nolist: items.length === 0 },
      { fullWidth },
    )}
    >
      <ul className="list-wrapper" id="suggestList">
        {items.map((item, key) => {
          return (
            <li className="list" key={item} id="pcSuggestItem">
              <button
                className="button"
                type="button"
                tabIndex="0"
                onClick={() => onClick(key)}
                ref={ref=>{els.current[key] = ref;}} 
              >
                {item}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PcSuggestList;